export default "__VITE_ASSET__C4JW3MVL__"